"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Damage = void 0;
const DamageType_1 = require("./enums/DamageType");
class Damage {
    constructor(type, amount) {
        this.type = type;
        this.amount = amount;
    }
}
exports.Damage = Damage;
Damage.None = new Damage(DamageType_1.DamageType.None, 0);
Damage.Sum = (damages) => damages.reduce((sum, next) => sum + next.amount, 0);
